import { Theme } from "@mui/material/styles";
import { alpha, SystemStyleObject } from "@mui/system";

const infoMissionStyles = {
  image: (theme: Theme): SystemStyleObject<Theme> => ({
    "& > span": {
      filter: `drop-shadow(0 0 45px ${alpha(
        theme.palette.secondary.main,
        0.75,
      )})`,
    },
  }),
};

export default infoMissionStyles;
